import { createMuiTheme, ThemeOptions } from '@material-ui/core';

import { googleBlue, googleGrey } from './Colors';

const options: ThemeOptions = {
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width: 600px)': {
        minHeight: 64,
      },
    },
  },
  overrides: {
    MuiMenuItem: {
      root: {
        paddingTop: 12,
        paddingBottom: 12,
      },
    },
    MuiTable: {
      root: {
        tableLayout: 'fixed',
      },
    },
    MuiTableCell: {
      root: {
        overflowWrap: 'break-word',
      },
    },
  },
};

// We need a new theme instance every time we toggle dark theme.
export function createLightTheme() {
  return createMuiTheme({
    ...options,
    palette: {
      primary: {
        main: googleBlue[500],
      },
      secondary: {
        main: googleBlue[500],
      },
      background: {
        default: '#ffffff',
      },
    },
  });
}

export function createDarkTheme() {
  return createMuiTheme({
    ...options,
    palette: {
      primary: {
        main: googleBlue[300],
      },
      secondary: {
        main: googleBlue[300],
      },
      background: {
        default: googleGrey[900],
        paper: googleGrey[800],
      },
      type: 'dark',
    },
  });
}
